module.exports = __webpack_public_path__ + "media/images/btn-drawer-close-30291a947b5ff226a46f0473312368c3.svg";